/**
 * What a tool may do inside a subagent. Every tool declares one, so a new tool can't be left out
 * of the rules by accident. "Scoped" means one of several subagents started together, which own
 * separate scene groups of one shared video; a subagent running alone is unscoped.
 */
export enum SubagentAccess {
    /**
     * Edits the scene or scene group its `scene_id` / `scene_ids` / `scene_group_id` points at.
     * A scoped subagent may only point it at its own scene groups.
     */
    EDITS_TARGET = 'edits_target',
    /**
     * Creates or moves a scene group right after `after_scene_group_id` (or at the very start of
     * the video when omitted). A scoped subagent may only place after its own scene groups.
     */
    PLACEMENT = 'placement',
    /** Doesn't change the video: it reads it, or works outside it (search, lookups). */
    READ_ONLY = 'read_only',
    /**
     * Reads the video by rendering or probing the live copy, so scoped subagents take turns with
     * these rather than catch each other mid-render.
     */
    CAPTURE = 'capture',
    /**
     * Asks the user and waits for an answer. The chat shows one question at a time, so scoped
     * subagents take turns with these.
     */
    ASKS_USER = 'asks_user',
    /**
     * Changes something that belongs to the whole video rather than a scene group. Kept from
     * scoped subagents; a subagent running alone may use it.
     */
    BLOCKED = 'blocked',
    /**
     * Makes no sense in any subagent: it starts subagents, shows the user something outside the
     * chat's question flow, ends the root's turn, or is the root's whole-video review (which the
     * user can skip in one place). Never given to a subagent.
     */
    UNAVAILABLE = 'unavailable',
}
